var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelSubCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9993 67.2941C52.4088 67.2941 67.3327 52.3703 67.3327 33.9608C67.3327 15.5513 52.4088 0.627441 33.9993 0.627441C15.5899 0.627441 0.666016 15.5513 0.666016 33.9608C0.666016 52.3703 15.5899 67.2941 33.9993 67.2941Z",
    fill: "#FF5A26",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.093 30.8722C28.3113 25.1776 29.9204 22.3303 32.1285 21.5973C33.3431 21.1941 34.6517 21.1941 35.8663 21.5973C38.0745 22.3303 39.6835 25.1776 42.9018 30.8722C46.1201 36.5668 47.7291 39.414 47.2465 41.734C46.9809 43.0104 46.3266 44.1681 45.3774 45.0412C43.6521 46.6283 40.4339 46.6283 33.9974 46.6283C27.5609 46.6283 24.3427 46.6283 22.6173 45.0412C21.6682 44.1681 21.0139 43.0104 20.7484 41.734C20.2657 39.414 21.8748 36.5668 25.093 30.8722Z",
    stroke: "#FF5A26",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3216 40.6281V35.2948C34.3216 34.6662 34.3216 34.352 34.1263 34.1566C33.9311 33.9614 33.6168 33.9614 32.9883 33.9614",
    stroke: "#FF5A26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9883 29.9614H34.0003",
    stroke: "#FF5A26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelSubCaution);
export default __webpack_public_path__ + "static/media/cancelSubCaution.953026b51d4bc4e911ea23f09fc721c1.svg";
export { ForwardRef as ReactComponent };